const FilledAlertIcon = (props) => {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" {...props}>
      <path
        d="M9.833 3.398a.843.843 0 0 0-.424.231c-.101.102-6.635 11.765-6.704 11.968-.092.27-.006.604.212.821.27.271-.352.25 7.135.241l6.666-.009.166-.085a.823.823 0 0 0 .422-.898c-.025-.111-1.066-2.005-3.209-5.841-3.639-6.511-3.396-6.083-3.519-6.205a.854.854 0 0 0-.745-.223m.505 4.419a.8.8 0 0 1 .2.206l.079.127v2.878l-.101.143c-.139.197-.289.278-.516.278-.227 0-.377-.081-.516-.278l-.101-.143V8.15l.078-.124a.62.62 0 0 1 .877-.209m-.026 5.162c.157.066.347.243.431.401.1.191.1.549 0 .739a.843.843 0 0 1-.743.459.843.843 0 0 1-.743-.459c-.1-.19-.1-.548 0-.739.082-.154.271-.333.424-.399.134-.059.492-.06.631-.002"
        fillRule="evenodd"
      />
    </svg>
  );
};

export { FilledAlertIcon };
